export default "__VITE_ASSET__B9MNNUb9__"